// public/v3/src/lib/month.js — month-key helpers.
//
// The Time Logs / Studio quick-log handlers need to date new entries into
// the user's CURRENT view (the active chrome-bar month), not today's date.
// Otherwise, when the user navigates back to a prior month and quick-logs,
// the entry vanishes from the table (filtered out by the monthly view).

// Returns YYYY-MM-DD for the active month. If today falls inside it, returns
// today. Otherwise, returns the last day of that month so the entry sits
// inside the user's current view.
export function entryDateForMonth(monthKey) {
  const today = new Date().toISOString().slice(0, 10);
  if (typeof monthKey === 'string' && today.startsWith(monthKey)) return today;
  const m = /^(\d{4})-(\d{2})$/.exec(monthKey || '');
  if (!m) return today;
  const y = Number(m[1]);
  const mm = Number(m[2]); // 1-based
  const lastDay = new Date(y, mm, 0).getDate();
  return `${monthKey}-${String(lastDay).padStart(2, '0')}`;
}
